import { Component, OnInit } from "@angular/core";
import "@angular/compiler"
import { AuthService, LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { AnalyticsService } from "projects/sepidz-web-framework/src/lib/services/analytics.service";
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  providers: [AnalyticsService],
})
export class AppComponent implements OnInit {
  constructor(private analytics: AnalyticsService, public localStorage: LocalStoreManager, 
    private authService: AuthService) {}

  ngOnInit() {
    this.analytics.trackPageViews();
    if (!this.authService.getIsLoggedIn()) {
      this.localStorage.clearAllStorage();
    }
    const mamad = navigator.userAgent;
  }
}
